// Held in memory because File objects cannot be stored in the persisted Redux form data.
let cnyPayoutDocument: File | null = null;

export const getCnyPayoutDocument = () => cnyPayoutDocument;

export const setCnyPayoutDocument = (file: File | null) => {
  cnyPayoutDocument = file;
};
